<template>
    <div class="drawing-wrapper">
        <div class="description-field">
            <textarea v-model="drawingCallBack.description" placeholder="توضیحات (اختیاری)"
                class="description-input"></textarea>
        </div>

        <div class="canvas-wrapper">
            <canvas ref="canvas" id="drawing-canvas"></canvas>
        </div>

        <div class="drawing-controls">
            <div class="controls-wrapper">
                <div class="color-palette">
                    <button v-for="color in colors" :key="color"
                        :style="{ backgroundColor: color, border: color === '#ffffff' ? '2px solid #ccc' : '' }"
                        class="color-btn" :class="{ active: currentColor === color }" @click="setColor(color)"></button>
                </div>

                <div class="control-buttons">
                    <BaseButton title="پاک کردن" variant="danger" @click="clearCanvas" />
                    <BaseButton title="بزرگنمایی" variant="outline-danger" @click="zoomIn" />
                </div>
            </div>

            <div class="brush-controls">
                <label for="brush-size">اندازه قلم:</label>
                <input type="range" id="brush-size" v-model="currentBrushSize" min="1" max="50" />
                <span>{{ currentBrushSize }}px</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import BaseButton from '@/components/UiCompunents/BaseButton.vue'

// eslint-disable-next-line no-undef
const props = defineProps({
    recordId: { type: Number, required: true },
    editingFile: { type: Object, default: null }
});
// eslint-disable-next-line no-undef
const emit = defineEmits(["confirm", "close"]);
// eslint-disable-next-line no-undef
defineExpose({
    confirm
})

const photos = ref([])
const canvas = ref(null);
let ctx = null;
const isDrawing = ref(false);

const currentColor = ref("#000000");
const currentBrushSize = ref(5);
const zoomFactor = ref(1);

const colors = ["#000000", "#ff0000", "#00ff00", "#0000ff", "#ffff00", "#ff00ff", "#00ffff", "#ffffff"];
const drawingCallBack = {
    description: '',
    recordId: props.recordId,
    photos: photos.value,
    isEditing: false
}
// تغییر رنگ
function setColor(color) {
    currentColor.value = color;
}

// شروع کشیدن
function startDrawing(e) {
    if (!ctx) return;
    isDrawing.value = true;
    draw(e);
}

// توقف کشیدن
function stopDrawing() {
    isDrawing.value = false;
    if (ctx) ctx.beginPath();
}

// کشیدن
function draw(e) {
    if (!isDrawing.value || !ctx || !canvas.value) return;

    ctx.lineWidth = currentBrushSize.value;
    ctx.lineCap = "round";
    ctx.strokeStyle = currentColor.value;

    const rect = canvas.value.getBoundingClientRect();
    const scaleX = canvas.value.width / rect.width;
    const scaleY = canvas.value.height / rect.height;

    let x, y;
    if (e.touches && e.touches.length > 0) {
        e.preventDefault();
        x = (e.touches[0].clientX - rect.left) * scaleX;
        y = (e.touches[0].clientY - rect.top) * scaleY;
    } else {
        x = (e.clientX - rect.left) * scaleX;
        y = (e.clientY - rect.top) * scaleY;
    }

    ctx.lineTo(x, y);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(x, y);
}

// پاک کردن بوم
function clearCanvas() {
    if (!ctx || !canvas.value) return;
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, canvas.value.width, canvas.value.height);
}

// بزرگنمایی canvas
function zoomIn() {
    // ذخیره تصویر فعلی
    const currentImageData = canvas.value.toDataURL('image/png');
    zoomFactor.value *= 1.2;
    resizeCanvas();
    // بارگذاری مجدد تصویر
    const img = new Image();
    img.onload = function() {
        ctx.drawImage(img, 0, 0, canvas.value.width, canvas.value.height);
    };
    img.src = currentImageData;
}

// تایید نقاشی و تبدیل به File
function confirm() {
    if (!canvas.value) return;
    //جهت نمایش در مرورگر
    // const photoData = canvas.value.toDataURL('image/png')
    // photos.value.push(photoData)

    const dataURL = canvas.value.toDataURL('image/png');

    // تبدیل Base64 به Blob
    const blob = dataURLtoBlob(dataURL);

    // ساخت File شبیه فایلی که از درایو انتخاب می‌کنی
    const file = new File([blob], 'drawing.png', { type: 'image/png' });

    // اگر در حال ویرایش هستیم، فقط یک فایل ارسال کن
    if (props.editingFile) {
        // emit('confirm', { recordId: props.recordId, photos: [file], isEditing: true, description: drawingDescription })
        drawingCallBack.photos = [file];
        drawingCallBack.isEditing = true;
    } else {
        // اگر نقاشی جدید است، به آرایه اضافه کن
        photos.value.push(file)
        // emit('confirm', { recordId: props.recordId, photos: photos.value, isEditing: false, description: drawingDescription })
        drawingCallBack.photos = photos.value;
        drawingCallBack.isEditing = false;

    }

    return drawingCallBack;
}
// تابع کمکی برای تبدیل Base64 به Blob
function dataURLtoBlob(dataurl) {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}
// تنظیم سایز canvas
function resizeCanvas() {
    if (!canvas.value) return; // اگر هنوز null بود، کاری نکن
    const c = canvas.value;
    const container = c.parentElement;
    const width = container.clientWidth - 20; // 20px padding
    const aspectRatio = 3 / 1.5; // نسبت تنظیم شده تا فضای کافی برای کنترل‌ها باشد
    const height = (width / aspectRatio) * zoomFactor.value;

    c.width = width;
    c.height = height;

    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, c.width, c.height);
}


// بارگذاری تصویر موجود در canvas برای ویرایش
function loadExistingImage() {
    if (props.editingFile && props.editingFile.file) {
        const img = new Image();
        img.onload = function () {
            if (ctx && canvas.value) {
                // پاک کردن canvas
                ctx.fillStyle = "white";
                ctx.fillRect(0, 0, canvas.value.width, canvas.value.height);

                // رسم تصویر موجود
                ctx.drawImage(img, 0, 0, canvas.value.width, canvas.value.height);
            }
        };

        // اگر فایل یک File object است
        if (props.editingFile.file instanceof File) {
            const reader = new FileReader();
            reader.onload = function (e) {
                img.src = e.target.result;
            };
            reader.readAsDataURL(props.editingFile.file);
        } else if (typeof props.editingFile.file === 'string') {
            // اگر فایل یک data URL است
            img.src = props.editingFile.file;
        }
    }
}

onMounted(() => {
    ctx = canvas.value.getContext("2d");
    resizeCanvas(); // الان canvas.value حتما مقدار دارد

    // بارگذاری تصویر موجود اگر در حال ویرایش هستیم
    loadExistingImage();

    window.addEventListener("resize", resizeCanvas);

    // رویدادهای موس
    canvas.value.addEventListener("mousedown", startDrawing);
    canvas.value.addEventListener("mousemove", draw);
    canvas.value.addEventListener("mouseup", stopDrawing);
    canvas.value.addEventListener("mouseout", stopDrawing);

    // رویدادهای تاچ
    canvas.value.addEventListener("touchstart", startDrawing);
    canvas.value.addEventListener("touchmove", draw);
    canvas.value.addEventListener("touchend", stopDrawing);

    window.addEventListener("resize", resizeCanvas);
});

onBeforeUnmount(() => {
    window.removeEventListener("resize", resizeCanvas);
});
</script>



<style scoped>
/* همون استایل قبلی که برای نقاشی گذاشتید، یا ساده‌تر */
.drawing-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    width: 100%;
}

.description-field {
    width: 100%;
    margin-bottom: 5px;
}

.description-input {
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 8px;
    height: 38px;
    width: 100%;
    resize: none;
    font-family: inherit;
    background-color: var(--background-color);
    color: var(--text-color);
    direction: rtl;
    overflow: hidden;
}

.bottom-controls {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
    padding: 0 10px;
    margin-top: 3px;
}

.action-buttons {
    display: flex;
    gap: 8px;
    align-items: center;
}

.canvas-wrapper {
    display: flex;
    justify-content: center;
    background: white;
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    width: 100%;
}

canvas {
    border: 1px solid #ddd;
    border-radius: 8px;
    cursor: crosshair;
    width: 100%;
    height: auto;
}

.controls-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;
    gap: 20px;
}

.color-palette {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
}

.control-buttons {
    display: flex;
    gap: 10px;
    margin-left: 10px;
}

.color-btn {
    width: 30px;
    height: 30px;
    border: 2px solid #ddd;
    border-radius: 50%;
    cursor: pointer;
}

.color-btn.active {
    border-color: #007bff;
    transform: scale(1.1);
}

.action-buttons {
    display: flex;
    justify-content: center;
    gap: 10px;
}

.btn {
    padding: 8px 14px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.btn-danger {
    background: #dc3545;
    color: #fff;
}

.btn-success {
    background: #1474f2;
    color: #fff;
}

.btn-secondary {
    background: #6c757d;
    color: #fff;
}

.btn-info {
    background: #17a2b8;
    color: #fff;
}
</style>
